module.exports = __webpack_public_path__ + "img/other.00193223.jpg";